<template>
  <b-form-group
    label="Çalışma Günü"
    label-for="time-picker-group"
  >
    <validation-provider
      #default="{ errors }"
      name="Çalışma Günü"
      rules="required"
    >
      <b-form-datepicker
        v-model="workItem.wdate"
        placeholder="Çalışma Tarihi"
        v-bind="{labelNoDateSelected: 'Teslim Tarihi',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
        locale="tr"
        start-weekday="1"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import { required } from '@validations'
import {
  BFormGroup, BFormDatepicker,
} from 'bootstrap-vue'

export default {
  name: 'WorkTimes',
  components: {
    BFormGroup,
    BFormDatepicker,
    ValidationProvider,
  },
  data() {
    return {
      required,
      startTime: null,
      endTime: null,
    }
  },
  computed: {
    workItem() {
      return this.$store.getters['serviceWorks/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
